export async function fetchWaveformData(url: string) {
  const response = await fetch(url)
  const readableStream = response.body

  if (!response.ok || !readableStream) {
    return null
  }

  const decompressedReadableStream = readableStream.pipeThrough(
    new DecompressionStream('gzip'),
  )
  // ref: https://stackoverflow.com/questions/40385133/retrieve-data-from-a-readablestream-object
  const text = await new Response(decompressedReadableStream).text()
  const peaks = JSON.parse(text) as number[][]

  return peaks.map((peaksItem) => {
    return peaksItem.map((item) => item / 1000)
  })
}
